<template>
  <v-dialog v-model="show" persistent>
    <v-card class="flex-col-center-center gap-4 pa-6 direction-ltr">
      <CompositionResult :composition="balanceResult.composition" />
      <ProductResult :product="balanceResult.product" />
      <OtherResult title="Reformer" :tableData="balanceResult.reformer" />
      <OtherResult title="Recuperator" :tableData="balanceResult.recuperator" />
      <v-btn
        class="white--text"
        color="mainBlue"
        min-width="250"
        @click="confirm"
      >
        {{ $t("confirmAndClose") }}
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import CompositionResult from "@/components/balance/CompositionResult.vue";
import ProductResult from "@/components/balance/ProductResult.vue";
import OtherResult from "@/components/balance/OtherResult.vue";
import { mapGetters } from "vuex";

export default {
  name: "BalanceResult",

  props: {
    show: { type: Boolean, default: false },
  },

  computed: {
    ...mapGetters(["balanceResult"]),
  },

  methods: {
    confirm() {
      this.$emit("close");
    },
  },

  components: {
    CompositionResult,
    ProductResult,
    OtherResult,
  },
};
</script>
